
import { RentalStatus } from '@/api/dtos/Booking.schema'
import { Component, ModelSync, Prop, Vue } from 'vue-property-decorator'
import CancelButton from '../buttons/CancelButton.vue'
import DangerButton from '../buttons/DangerButton.vue'
import EditFrame from '../EditFrame.vue'
import { rentalStatusToGerman } from '@/misc/i18n'

@Component({
  components: {
    EditFrame,
    CancelButton,
    DangerButton
  }
})
export default class BookingProgressBar extends Vue {
  @Prop()
  bookingState!: RentalStatus

  @Prop({
    default: 515
  })
  width!: number

  rentalStatusToGerman = rentalStatusToGerman // TODO consider moving this to a plugin

  get timeLineLabels (): { stateName: string; color: string }[] {
    if (this.bookingState === 'CANCELLED') {
      return [
        {
          stateName: 'CANCELLED',
          color: 'bpbPrimary'
        }
      ]
    }
    const states: RentalStatus[] = [
      'CREATED',
      'PAYED',
      'CONFIRMED',
      'RUNNING',
      'DONE'
    ]
    const labels: { stateName: string; color: string }[] = []
    let reachedLevel = false
    for (const status of states) {
      labels.push({
        stateName: status,
        color: reachedLevel ? 'grey' : 'bpbPrimary'
      })
      if (this.bookingState === status) reachedLevel = true
    }

    return labels
  }
}
